module.exports = __webpack_public_path__ + "media/images/sales-225ef11a.svg";